import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchFaqs = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/subscriber-group-faq/${subscriberGroupId}`);
    return res?.data?.data?.faq ?? "";
};

export const useFaqs = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["faqs", subscriberGroupId],
        queryFn: () => fetchFaqs(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    return {
        faqs: data ?? "",
        isLoading,
    };
};
